import { cloneDeep } from 'lodash';
import { actions } from './actions';
import { mutations } from './mutations';
import { getters } from './getters';

const localPurchasedVoices = localStorage.getItem('purchasedVoices') ? JSON.parse(localStorage.getItem('purchasedVoices')) : [];

const defaultState = {
    mediaVoicePreview: 'https://www.voicemod.net/static/demos/',
    mediaVoiceIcon: 'https://www.voicemod.net/static/icons-rebrand/',
    purchasedVoices: localPurchasedVoices,
    panelConfiguredVoices: [],
    panelMinimumTime: 15,
};

export const panel = {
    namespaced: true,
    state: cloneDeep(defaultState),
    actions,
    mutations,
    getters,
};
